import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-send-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M3.00137 31.8348C2.65637 31.8348 2.31137 31.7028 2.04737 31.4388C1.51937 30.9123 1.51937 30.0573 2.04737 29.5308L6.34037 25.2378C6.86837 24.7098 7.72187 24.7098 8.24837 25.2378C8.77637 25.7643 8.77637 26.6193 8.24837 27.1458L3.95537 31.4388C3.69287 31.7028 3.34787 31.8348 3.00137 31.8348Z"
        fill="#F8BB04"
      />
      <path
        d="M6.47695 42.8749C6.13195 42.8749 5.78695 42.7429 5.52295 42.4789C4.99495 41.9524 4.99495 41.0974 5.52295 40.5709L13.599 32.4949C14.127 31.9669 14.9805 31.9669 15.507 32.4949C16.035 33.0214 16.035 33.8764 15.507 34.4029L7.43095 42.4804C7.16695 42.7444 6.82195 42.8749 6.47695 42.8749Z"
        fill="#F8BB04"
      />
      <path
        d="M17.517 46.3502C17.172 46.3502 16.827 46.2182 16.563 45.9542C16.035 45.4277 16.035 44.5727 16.563 44.0462L20.856 39.7532C21.384 39.2252 22.2375 39.2252 22.764 39.7532C23.292 40.2797 23.292 41.1347 22.764 41.6612L18.471 45.9542C18.2085 46.2182 17.8635 46.3502 17.517 46.3502Z"
        fill="#F8BB04"
      />
      <path
        d="M41.2092 3.12635L5.95324 13.6413C3.29074 14.4348 3.10474 18.1338 5.67274 19.1913L20.8107 25.4298C20.8767 25.2693 20.9727 25.1193 21.1032 24.9903L28.8447 17.2488C29.3727 16.7208 30.2262 16.7208 30.7527 17.2488C31.2807 17.7753 31.2807 18.6303 30.7527 19.1568L23.0112 26.8983C22.8807 27.0288 22.7307 27.1263 22.5702 27.1923L28.8117 42.3378C29.8677 44.9013 33.5607 44.7153 34.3527 42.0573L44.8707 6.78785C45.5397 4.54685 43.4517 2.45885 41.2092 3.12635Z"
        fill="#0E89D8"
      />
    </svg>
  `,
})
export class SendIconComponent {}
